<template>
  <b-card header="Assign manager to lock/lock group">
    <b-form id="assign-manager-form">
      <b-form-group>
        <b-input-group>
          <b-input-group-prepend><b-input-group-text>Manager</b-input-group-text></b-input-group-prepend>
          <select-manager :locationId=locationId></select-manager>
          <b-input-group-append><b-input-group-text><i class="fa fa-user"></i></b-input-group-text></b-input-group-append>
        </b-input-group>
      </b-form-group>
      <b-form-group>
        <b-input-group>
          <b-input-group-prepend><b-input-group-text>Select Lock</b-input-group-text></b-input-group-prepend>
            <select-lock :locationId=locationId></select-lock>
          <b-input-group-append><b-input-group-text><i class="fa fa-key"></i></b-input-group-text></b-input-group-append>
        </b-input-group>
      </b-form-group>
      <b-form-group>
        <b-input-group>
          <b-input-group-prepend><b-input-group-text>Select Lock Group</b-input-group-text></b-input-group-prepend>
            <select-lock-group :locationId=locationId></select-lock-group>
          <b-input-group-append><b-input-group-text><i class="fa fa-group"></i></b-input-group-text></b-input-group-append>
        </b-input-group>
      </b-form-group>
      <b-form-group>
        <b-input-group>
          <b-input-group-prepend><b-input-group-text>Start</b-input-group-text></b-input-group-prepend>
          <b-form-input type="date" id="startDate" v-model="formData.startDate" placeholder="StartDate"></b-form-input>
          <b-form-input type="time" id="startTime" v-model="formData.startTime"></b-form-input>
          <b-input-group-append><b-input-group-text><i class="fa fa-calendar"></i></b-input-group-text></b-input-group-append>
        </b-input-group>
      </b-form-group>
      <b-form-group>
        <b-input-group>
          <b-input-group-prepend><b-input-group-text>End</b-input-group-text></b-input-group-prepend>
          <b-form-input type="date" id="endDate" v-model="formData.endDate" placeholder="EndDate"></b-form-input>
          <b-form-input type="time" id="endTime" v-model="formData.endTime"></b-form-input>
          <b-input-group-append><b-input-group-text><i class="fa fa-calendar"></i></b-input-group-text></b-input-group-append>
        </b-input-group>
      </b-form-group>
      <div class="form-group form-actions">
        <b-button @click="submitData" type="submit" size="sm" variant="primary">Assign</b-button>
        <b-button @click="onReset" type="reset" size="sm" variant="primary">Reset</b-button>
      </div>
    </b-form>
  </b-card>
</template>

<script>
let qs = require('qs')
const constants = require('./shared/constants')
const BASE = constants.NEWPORT_CONST.API_URL
const API_ADD_LOCK = BASE + '/api/lockManagerMappers/addLock'
const API_ADD_LOCKGROUP = BASE + '/api/lockManagerMappers/addLockGroup'

function postdata (url, data) {
  const thisForm = document.getElementById('assign-manager-form')
  var partsStartDate = data.startDate.split('-')
  var partsEndDate = data.endDate.split('-')
  data.lockManagerId = selectedManagerInput.value
  data.startDate = new Date(partsStartDate[0], partsStartDate[1] - 1, partsStartDate[2]).getTime()
  data.endDate = new Date(partsEndDate[0], partsEndDate[1] - 1, partsEndDate[2]).getTime()
  data.lockId = selectedLockInput.value
  data.lockGroupId = selectedLockGroupInput.value
  return fetch(url, {
    body: qs.stringify(data),
    headers: {
      'content-type': 'application/x-www-form-urlencoded'
    },
    method: 'POST'
  })
    .then(res => res.json())
}

export default {
  name: 'manager-form',
  data () {
    return {
      mylocks: {},
      startDate: '',
      endDate: '',
      formData: {
        client_id: constants.NEWPORT_CONST.CLIENT_ID,
        client_secret: constants.NEWPORT_CONST.CLIENT_SECRET,
        accessToken: localStorage.getItem('token'),
        lockId: null,
        lockGroupId: null,
        lockManagerId: null,
        addDate: '',
        endDate: '',
        startDate: '',
        startTime: '',
        endTime: ''
      }
    }
  },
  props: ['locationName', 'locationId', 'locationDescription'],
  mounted () {
    this.$data.formData.addDate = constants.getToday()
    this.$data.formData.startDate = constants.getToday()
    this.$data.formData.endDate = constants.getEndDate()
    this.$data.formData.startTime = constants.getTimeNow()
    this.$data.formData.endTime = constants.getTimeNow()
  },
  methods: {
    submitData (evt) {
      evt.preventDefault()
      const thisForm = document.getElementById('assign-manager-form')
      const selectedManagerInput = thisForm.querySelector('select[name=listManager]')
      const selectedLockInput = thisForm.querySelector('select[name=listLock]')
      const selectedLockGroupInput = thisForm.querySelector('select[name=listLockGroup]')
      const lock = selectedLockInput.value
      const lockGroup = selectedLockGroupInput.value
      const manager = selectedManagerInput.value
      if (lock !== '' && lockGroup !== '') {
        alert('Please select Lock OR Location. Not Both')
      } else {
        if (manager !== '') {
          if (lock !== '') {
            postdata(API_ADD_LOCK, this.formData)
              .then(data => {
                console.log(data)
                this.formData.addDate = constants.getToday()
                this.formData.startdate = constants.getToday()
                this.formData.enddate = constants.getEndDate()
                this.formData.startTime = constants.getTimeNow()
                this.formData.endTime = constants.getTimeNow()
              })
              .catch(error => {
                console.error(error)
              })
            location.reload()
          } else if (lockGroup !== '') {
            postdata(API_ADD_LOCKGROUP, this.formData)
              .then(data => {
                console.log(data)
                this.formData.addDate = constants.getToday()
                this.formData.startdate = constants.getToday()
                this.formData.enddate = constants.getEndDate()
                this.formData.startTime = constants.getTimeNow()
                this.formData.endTime = constants.getTimeNow()
              })
              .catch(error => {
                console.error(error)
              })
            location.reload()
          } else {
            alert('Please select lock or location')
          }
        } else {
          alert('Please select manager')
        }
      }
    },
    onReset (evt) {
      evt.preventDefault()
      this.formData.lockId = ''
      this.formData.managerId = ''
      this.formData.addDate = constants.getToday()
      this.formData.startdate = constants.getToday()
      this.formData.enddate = constants.getEndDate()
      this.formData.startTime = constants.getTimeNow()
      this.formData.endTime = constants.getTimeNow()
      this.show = false
      this.$nextTick(() => {
        this.show = true
      })
    },
    validateBeforeSubmit () {
      this.$validator.validateAll().then((result) => {
        if (result) {
          alert('From Submitted!')
        }
      })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/views/base/ManagerForm.vue